import React from 'react';
import { ButtonBase, makeStyles } from '@material-ui/core';
import { ResetIcon } from '../Icon';

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: '1.5rem',
    color: '#7D86A9',
  },
}));

const RefreshButton = ({ handleRefresh }) => {
  const classes = useStyles();
  return (
    <ButtonBase onClick={handleRefresh}>
      <ResetIcon className={classes.icon} />
    </ButtonBase>
  );
};

export default RefreshButton;
